import * as z from "zod";
import { requiredString } from "components/form/utils";

export const toolSchema = z.object({
  name: requiredString(),
  type: requiredString(),
});
